import { Controller } from 'stimulus';

class WishlistController extends Controller {
  onHeartClick({ currentTarget }) {
    const isLiked = currentTarget.classList.contains('is-liked');
    const removeFromView = currentTarget.dataset.removeFromView !== 'undefined'
      && currentTarget.dataset.removeFromView;
    const data = {
      modelType: currentTarget.dataset.modelType,
      modelId: parseInt(currentTarget.dataset.modelId, 10),
      wishlistId: currentTarget.dataset.wishlistId,
    };

    if (isLiked && removeFromView) {
      this.removeFromView(currentTarget);
    }

    currentTarget.classList[isLiked ? 'remove' : 'add']('is-liked');

    WishlistController[isLiked ? 'remove' : 'add'](data)
      .then(() => this.getItems());
  }

  // eslint-disable-next-line class-methods-use-this
  removeFromView(target) {
    const mediaItem = $(target).parents('.media-item');

    $(mediaItem).fadeOut(() => $(mediaItem).remove());
  }

  outputCount(count) {
    this.heartTarget.classList[count > 0 ? 'add' : 'remove']('is-filled');
    this.countTarget.innerText = `(${count})`;
  }

  /**
   * Get wishlist item count
   */
  getItems() {
    $.ajax({
      url: window.app.api.wishlist.items,
      method: 'GET',
      success: (res) => {
        this.outputCount(res.count);
      },
      error: () => {
        this.outputCount(0);
      },
    });
  }

  /**
   * Add item to wishlist
   *
   * @param data
   * @returns Promise
   */
  static add(data) {
    return $.ajax({
      url: window.app.api.wishlist.add,
      method: 'POST',
      data: {
        model_type: data.modelType,
        model_id: data.modelId,
      },
    });
  }

  /**
   * Remove item from wishlist
   *
   * @param data
   * @returns Promise
   */
  static remove(data) {
    return $.ajax({
      url: window.app.api.wishlist.remove,
      method: 'POST',
      data: {
        _method: 'DELETE',
        model_type: data.modelType,
        model_id: data.modelId,
        wishlist_id: data.wishlistId,
      },
    });
  }
}

WishlistController.targets = [
  'count',
  'heart',
];

export default WishlistController;
